import { useTranslation } from 'react-i18next';
import LandingpageHeader from '../header/LandingpageHeader';
import Footer from './Footer';

export default function FooterContact() {
    const { t } = useTranslation();

    return (

        <div className="container">

            <LandingpageHeader />

            <h3 style={{ textAlign: 'center' }}>{t('deTranslation.pageContact.title')}</h3>

            <Footer />
        </div>
    );
}
